import { useEffect } from "react";
import { cadesplugin } from "@rshbintech.dboul/utils";

import { UseCadesPluginOptions } from "./types";

export const useCadesPlugin = ({
  isHookInitialized,
  setIsPluginInit,
  setError,
}: UseCadesPluginOptions) => {
  useEffect(() => {
    if (!isHookInitialized) {
      return;
    }

    const initCadesPlugin = async () => {
      // cadesPlugin() проверяет, записан ли он в обьект window
      // и если да, то считает что крипто про работает
      // удаляем для проверки работоспособности плагина
      /* eslint-disable */
      // @ts-ignore
      window.cadesplugin && delete window.cadesplugin;

      // cadesPlugin() - вернет undefined либо промис с undefined или ошибкой
      const cades = cadesplugin();

      if (cades instanceof Promise) {
        await cades
          ?.then(() => {
            setIsPluginInit(true);
          })
          .catch((e) => {
            setError(e);
          });
      } else {
        setIsPluginInit(true);
      }
    };

    initCadesPlugin();
  }, [isHookInitialized]);
};
